import { useState, useEffect } from "react";
import { useFormik } from "formik";
import PlatformDefaultsForm from "@serie3/mymediaplanner/Modules/Social/Forms/PlatformDefaultsForm";
import crudApi from "@serie3/common/api/crudApi";
import SocialEndpoints from "@serie3/mymediaplanner/Modules/Social/endpoints";
import { PlatformFormLayout } from "./PlatformFormShared";

const PostPlatformSettings = ({ post, show }) => {
  const [activeKey, setActiveKey] = useState("youtube");

  const formik = useFormik(PlatformDefaultsForm.createPostPlatformSettingsForm(post?.id));

  useEffect(() => {
    if (!post?.id || !show) return;
    const load = async () => {
      const response = await crudApi.justGet(
        SocialEndpoints.posts.platformSettings + post.id + "/platform-settings"
      );
      if (response.ok && response.data) {
        formik.setValues(PlatformDefaultsForm.setEditData(response.data));
      }
    };
    load();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [post?.id, show]);

  if (!post?.id) return null;

  return (
    <PlatformFormLayout
      formik={formik}
      activeKey={activeKey}
      setActiveKey={setActiveKey}
      onSubmit={formik.handleSubmit}
    />
  );
};

export default PostPlatformSettings;
